import { render } from "./OrderItemPlaceholder.vue?vue&type=template&id=c5a3f474"
import script from "./OrderItemPlaceholder.vue?vue&type=script&lang=js"
export * from "./OrderItemPlaceholder.vue?vue&type=script&lang=js"

import "./OrderItemPlaceholder.vue?vue&type=style&index=0&id=c5a3f474&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__